<template>
    <ul :class="ulClass">
        <router-link v-for="item in items" class="nav-item" :to="item.link" tag="li" :key="item.id" v-on:click.native="closeNav">
            <a class="nav-link">{{ item.label }}</a>
        </router-link>
    </ul>
</template>

<script>
    export default {
        props: ['items', 'ulClass'],
        methods: {
            closeNav: function() {
                $('.navbar-mobile button').click();
            }
        }
    }
</script>


// WEBPACK FOOTER //
// src/components/Navbar.links.vue